// Thin wrapper around authenticatedFetch for the Adidas MAP tool.
// Mirrors InventoryRebalancing/apiClient.js. Response shapes are unchanged
// from the standalone app's api.ts.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/adidas-map';

async function throwIfNotOk(resp) {
  if (resp.ok) return resp;
  let detail = '';
  try {
    const raw = await resp.text();
    try {
      const d = JSON.parse(raw).detail;
      detail = typeof d === 'string' ? d : d?.message ? d.message : raw;
    } catch {
      detail = raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240);
    }
  } catch { /* status alone is enough */ }
  const err = new Error(detail || `${resp.status} ${resp.statusText}`);
  err.status = resp.status;
  throw err;
}

const getJson = (path) => authenticatedFetch(`${BASE}${path}`).then(throwIfNotOk).then((r) => r.json());
const postNoContent = (path) => authenticatedFetch(`${BASE}${path}`, { method: 'POST' }).then(throwIfNotOk).then(() => undefined);

export const api = {
  status: () => getJson('/status'),
  search: (q) => getJson(`/search?q=${encodeURIComponent(q)}`),
  sku: (article, color) => getJson(`/sku/${encodeURIComponent(article)}/${encodeURIComponent(color)}`),
  // Multipart: let the browser set Content-Type (with the boundary).
  uploadFile: async (file, file2) => {
    const fd = new FormData();
    fd.append('file', file);
    if (file2) fd.append('file2', file2);
    const r = await authenticatedFetch(`${BASE}/upload`, { method: 'POST', body: fd });
    await throwIfNotOk(r);
    return r.json();
  },
  commitUpload: (id) => postNoContent(`/upload/${id}/commit`),
  cancelUpload: (id) => postNoContent(`/upload/${id}/cancel`),
  uploads: () => getJson('/uploads'),
};
